import { ReactElement } from 'react';

import LoadingFallback from '~components/LoadingFallback';

import { DashboardLoadingWrapperProps } from './types';

const DashboardLoadingWrapper = ({
  loading,
  children,
}: DashboardLoadingWrapperProps): ReactElement => {
  if (loading) return <LoadingFallback />;

  return children;
};

export default DashboardLoadingWrapper;
